<template>
  <div>
    <div class="player-settings">
      <button 
      class="button is-rounded" 
      :class="{ 'is-dark' : editRollOpen }"
      @click.prevent="toggleOpen('editRollOpen')">
        <span class="icon">
          <i class="fas fa-dice-d20"></i>
        </span>
        <span>Edit Roll</span>
      </button>
      <button 
      class="button is-rounded" 
      :class="{ 'is-dark' : settingsOpen }"
      @click.prevent="toggleOpen('settingsOpen')">
        <span>Edit Character</span>
        <span class="icon">
          <i class="fas fa-user-cog"></i>
        </span>
      </button>
    </div>
    <transition name="slide-fade-left">
      <div v-show="settingsOpen" class="player-edit box">
        <form @submit.prevent="editPlayer()">
          <div class="field">
            <p class="control has-icons-left">
              <input 
              class="input is-rounded is-large" 
              type="text" 
              v-model="member.name" 
              placeholder="Character Name" 
              required>
              <span class="icon is-left">
                <i class="fas fa-user-circle"></i>
              </span>
            </p>
          </div>
          <div class="field has-addons">
            <p class="control">
              <label 
              class="button is-rounded is-dark" 
              :class="{'is-outlined' : rollStyle !== 'app'}"
              for="style-app">Roll in App</label>
              <input 
              id="style-app"
              type="radio"
              name="rollStyle"
              :checked="rollStyle === 'app'"
              @change="updateRollStyle('app')"
              style="display:none">
            </p>
            <p class="control">
              <label 
              class="button is-rounded is-dark" 
              :class="{'is-outlined' : rollStyle !== 'manual'}"
              for="style-manual">Roll on the table</label>
              <input 
              id="style-manual"
              type="radio"
              name="rollStyle"
              :checked="rollStyle === 'mannual'"
              @change="updateRollStyle('manual')"
              style="display:none">
            </p>
          </div>
          <div v-if="rollStyle === 'app'" class="field">
            <p class="control has-icons-left">
              <input 
              class="input is-rounded is-large" 
              inputmode="numeric" 
              pattern="[0-9]*" 
              type="number" 
              v-model="member.modifier" 
              placeholder="Initiative Modifier"
              required>
              <span class="icon is-left">
                <i class="fas fa-plus-circle"></i>
              </span>
            </p>
          </div>
          <div class="field">
            <button class="button is-rounded is-medium is-info is-fullwidth" type="submit">Save Changes</button>
          </div>
          <hr>
          <div class="field">
            <button class="button is-rounded is-medium is-danger is-fullwidth is-outlined" @click.prevent="deletePlayer()">Delete Character</button>
          </div>
        </form>
      </div>
    </transition>
    <transition name="toggle-modal">
      <div v-show="editRollOpen || newRollOpen" class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-content">
          <div class="box">
            <div class="player-roll">
              <h3 class="title is-4">{{ member.name }}</h3>
              <div v-show="rollStyle === 'app' && !editRollOpen" class="field">
                <button class="button is-large is-primary is-fullwidth" @click.prevent="newRoll()">{{ rollButtonText }}</button>
              </div>
              <form v-show="rollStyle === 'manual' || editRollOpen" @submit.prevent="updateInitiative()">
                <div class="field">
                  <p class="control has-icons-left">
                    <input 
                    inputmode="numeric" 
                    pattern="[0-9]*" 
                    type="number" 
                    v-model="member.initiative" 
                    class="input is-rounded is-large"
                    placeholder="Initiative">
                    <span class="icon is-left">
                      <i class="fas fa-running"></i>
                    </span>
                  </p>
                  <p class="help">Enter your initiative.</p>
                </div>
                <div class="field">
                  <button class="button is-rounded is-medium is-info is-fullwidth" type="submit">Save Initiative</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slide-fade-up">
      <div v-show="newRollResult" class="notification is-info roll-result">
        <p v-show="newRollResult" class="subtitle is-3">{{ newRollResult }}</p>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { db } from '../main'

export default {
  name: 'PlayerEdit',
  props: {
    campaignId: String,
  },
  data () {
    return {
      members: [],
      isRolling: false,
      newRollResult: false,
      settingsOpen: false,
      editRollOpen: false,
      newRollOpen: false,
    }
  },
  firestore () {
    this.$bind('members', 
      db.collection('campaigns')
      .doc(this.campaignId)
      .collection('party')
      .where('user', '==', this.user.uid))
  },
  computed: {
    ...mapGetters(['user', 'rollStyle']),
    member () {
      if (this.members.length) {
        return this.members[0]
      } else {
        return {
          name: false,
          initiative: false,
          modifier: false
        }
      }
    },
    memberInitiative () {
      return this.member.initiative
    },
    rollButtonText () {
      let mod = this.member.modifier
      if (mod > 0) {
        return `Roll Initiative (+${mod})`
      }
      else if (mod < 0) {
        return `Roll Initiative (${mod})`
      }
      else {
        return 'Roll Initiative'
      }
    }
  },
  methods: {
    newRoll () {
      if (this.isRolling) return
      const roll = this.rollDice(1, 20)
      const mod = parseInt(this.member.modifier)
      const number = roll + mod
      this.newRollResult = `${roll} + ${mod} = ${number}`
      this.isRolling = true
      db.collection('campaigns')
        .doc(this.campaignId)
        .collection('party')
        .doc(this.member.id)
        .update({ 
          initiative: parseInt(number)
        })
        .then(() => {
          this.newRollOpen = false
          console.log('new role!')
          setTimeout(() => {
            this.newRollResult = false
            this.isRolling = false
          }, 5000);
        })
    },
    editPlayer() {
      db.collection('campaigns')
        .doc(this.campaignId)
        .collection('party')
        .doc(this.member.id)
        .update({ 
          name: this.member.name, 
          modifier: this.member.modifier
        })
        .then(() => {
          this.settingsOpen = false
          console.log('player updated!')
        })
    },
    updateInitiative () {
      db.collection('campaigns')
        .doc(this.campaignId)
        .collection('party')
        .doc(this.member.id)
        .update({ 
          initiative: parseInt(this.member.initiative), 
        })
        .then(() => {
          this.editRollOpen = false
          this.newRollOpen = false
          console.log('initiative updated!')
        })
    },
    deletePlayer () {
      db.collection('campaigns')
        .doc(this.campaignId)
        .collection('party')
        .doc(this.member.id)
        .delete()
        .then(() => {
          console.log('player deleted!')
        })
    },
    updateRollStyle (value) {
      this.$store.commit('updateRollStyle', value);
    },
    toggleOpen (varName) {
      this[varName] = (this[varName]) ? false : true
    }
  },
  watch: {
    members: function () {
      // console.log(oldMembers, newMembers)
      if (this.members.length) {
        if (this.members[0].initiative === null) {
          this.newRollOpen = true
        }
      }
    }
  },
}
</script>
<style scoped>
.player-settings {
  text-align: right;
  /* margin-bottom: 1em; */
}
.player-settings button {
  margin: 0 0 0.5em 0.5em;
}
.player-edit {
  margin-top: 1.5em;
}
.roll-result {
  position: fixed;
  z-index: 10;
  top: 100%;
  left: 0;
  right: 0;
  transform: translateY(-100%);
}
.notification.roll-result {
  border-radius: 0;
  width: 100%;
}
.modal-content {
  padding: 10px;
}
/* .box {
  border: 5px solid #003A85;
  border-radius: 10px;
  background: rgb(255, 255, 252);
  box-shadow: 0 2px 3px #0a0a0a1a, 0 0 0 1px #0a0a0a1a;
}
.box:before {
  content: none;
} */
.slide-fade-up-enter-active {
  transition: opacity .3s ease, transform 0.3s;
}
.slide-fade-up-leave-active {
  transition: opacity .3s ease, transform 0.3s;
}
.slide-fade-up-enter, .slide-fade-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
.slide-fade-left-enter-active {
  transition: opacity .3s ease, transform 0.3s;
}
.slide-fade-left-leave-active {
  transition: opacity .3s ease, transform 0.3s;
}
.slide-fade-left-enter, .slide-fade-left-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
.toggle-modal-enter-active {
  transition: opacity .2s ease;
}
.toggle-modal-leave-active {
  transition: opacity .2s ease;
}
.toggle-modal-enter, .toggle-modal-leave-to {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/PlayerEdit.vue